import { useState, useContext } from 'react';
import { makeStyles } from '@material-ui/styles';
import { FilledInput, Button, FormGroup, FormLabel, FormControl, Box, Grid, Collapse, Divider, Select, MenuItem } from '@material-ui/core';

import AuthContext from '../../context';
import { post } from '../../utils/api-services';
import helpers from '../../utils/helpers';
import themeColors from '../../assets/colors';

const useStyles = makeStyles(() => ({
    buttonContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'left',
        alignItems: 'center',
        marginBottom: 5
    },
    storeBtn: {
        marginLeft: 20,
        ...themeColors.blueBtn
    }
}));

const KardexDetailCreateAdjustment = ({ open, onClose, id, permissions }) => {

    const classes = useStyles();
    const { showToast, signOut, showLoader } = useContext(AuthContext);
    const [form, setForm] = useState({
        inventory: '-',
        qty: 0,
        note: ''
    });

    const handleChange = ({ target: { name, value } }) => setForm(prev => ({ ...prev, [name]: value }));

    const validate = () => {
        if (!['regular', 'storage'].includes(form.inventory)) {
            showToast('Inventory not allowed', 'error');
            return false;
        }
        if (!Number(form.qty)) {
            showToast('Qty field is required', 'error');
            return false;
        }
        if (!form.note.trim()) {
            showToast('Note field is required', 'error');
            return false;
        }

        const cond = window.confirm(`Are you sure you want to create this new adjustment "${form.qty}"?`);
        return cond;
    }

    const store = async () => {
        const cond = validate();
        if (cond) {
            showLoader(true);
            const response = await post(`/invKardex/${id}/store`, form);
            if (response.status === 200) {
                showToast(response.message);
                onClose();
                clear();
            } else {
                console.log('[KardexDetailCreateAdjustment] store error', response);
                helpers.failRequest(response, showToast, signOut);
            }
            showLoader(false);
        }
    }

    const clear = () => setForm({ inventory: '-', qty: 0, note: '' });

    return (
        <Collapse in={open}>
            <Divider />
            <h3>{'Create new adjustment'}</h3>
            <Grid container>
                <Grid item xs={6} md={3} lg={2}>
                    <FormGroup>
                        <FormLabel>{'Inventory'}</FormLabel>
                        <FormControl
                            variant='filled'
                            component={Box}
                            width='100%'
                        >
                            <Select
                                value={form.inventory}
                                onChange={({ target }) => setForm(prev => ({ ...prev, inventory: target.value }))}
                            >
                                <MenuItem value='-'>{'Choose a inventory'}</MenuItem>
                                <MenuItem value='regular'>{'Regular'}</MenuItem>
                                <MenuItem value='storage'>{'Storage'}</MenuItem>
                            </Select>
                        </FormControl>
                    </FormGroup>
                </Grid>
                <Grid item xs={6} md={3} lg={2}>
                    <FormGroup>
                        <FormLabel>{'Qty'}</FormLabel>
                        <FormControl
                            variant='filled'
                            component={Box}
                            width='100%'
                        >
                            <FilledInput
                                autoComplete='off'
                                type='number'
                                name='qty'
                                placeholder='12345'
                                value={form.qty}
                                onChange={handleChange}
                            />
                        </FormControl>
                    </FormGroup>
                </Grid>
                <Grid item xs={12} md={6} lg={5}>
                    <FormGroup>
                        <FormLabel>{'Note'}</FormLabel>
                        <FormControl
                            variant='filled'
                            component={Box}
                            width='100%'
                        >
                            <FilledInput
                                autoComplete='off'
                                type='text'
                                name='note'
                                placeholder='Note...'
                                value={form.note}
                                onChange={handleChange}
                            />
                        </FormControl>
                    </FormGroup>
                </Grid>
                <Grid item xs={12} lg={3} className={classes.buttonContainer}>
                    <Button
                        variant='contained'
                        color='secondary'
                        onClick={clear}
                    >
                        {'Cancel'}
                    </Button>
                    {
                        (permissions.create_attr) &&
                        <Button
                            variant='contained'
                            className={classes.storeBtn}
                            onClick={store}
                        >
                            {'Store'}
                        </Button>
                    }
                </Grid>
            </Grid>
        </Collapse>
    );
}

export default KardexDetailCreateAdjustment;